import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import { ColumnGrid } from "./ColumnGrid";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterValues } from "../DynamicFilters.config";
import { IDynamicColumnFilter } from "Interfaces/Utils";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { Box, Button, Grid, IconButton, Popover, Tooltip, Typography } from "@mui/material";
import { esES } from "@mui/x-date-pickers/locales";
import { useIntl } from "react-intl";

interface IFiltersToolbarProps {
  anchorEl: HTMLElement | null;
  filters: IDynamicColumnFilter[];
  filterValues: FilterValues;
  handleChange: (field: string, value: any) => void;
  onOtherComponentChange?: (value: string) => void;
  handleOpenMenu: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  handleCloseMenu: () => void;
  resetFilters: () => void;
  applyFilters: () => void;
};


const poppupWindowWidth = "800px !important";

export const FiltersToolbar = (props: IFiltersToolbarProps) => {
  const { formatMessage } = useIntl();
  const FILTERS_LABEL = formatMessage({ id: "filters.title" });
  const CLEAR_FILTERS_LABEL = formatMessage({ id: "filters.clear" });
  const APPLY_LABEL = formatMessage({ id: "filters.apply" });
  const CLOSE_FILTERS_LABEL = formatMessage({ id: "filters.close" });

  const { anchorEl, filters, filterValues, handleChange, handleOpenMenu, handleCloseMenu, resetFilters, applyFilters, onOtherComponentChange} = props;
  
  return (
    <>
      <Box>
        <IconButton
          sx={{
            color: Boolean(anchorEl) ? "primary.main" : "",
            border: 1,
            borderColor: "#E6E6E6",
            backgroundColor: "#FFFFFF",
            borderRadius: "15px",
            width: "142px",
            height: "58px",
            display: "flex",
            justifyContent: "space-around",
          }}
          aria-controls="simple-filter"
          aria-haspopup="true"
          onClick={(ev) => handleOpenMenu(ev)}
        >
          <FilterListIcon />
          <Typography marginLeft={"5px"}>{FILTERS_LABEL}</Typography>
        </IconButton>
      </Box>
      <Popover
        id="simple-filter"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        sx={{
          position: "absolute",
          top: "70px",
          "& .MuiPopover-paper": {
            border: "1px solid rgba(219, 224, 229, 0.65)",
            borderRadius: "12px",
            boxShadow: "rgba(0, 0, 0, 0.04) 0px 7px 7px 3px",
            width: poppupWindowWidth,
            maxHeight: "800px", // Reduzco la altura máxima del popover
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={"es"}
          localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
            {/* Título y botón de cierre */}
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ padding: "15px", borderBottom: "1px solid #E6E6E6" }}>
              <Typography sx={{ fontWeight: "500", fontSize: "16px" }} color={"primary"}>{FILTERS_LABEL}</Typography>
              <Tooltip title={CLOSE_FILTERS_LABEL} onClick={handleCloseMenu}>
                <IconButton>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Contenedor con scroll más pequeño */}
            <Box sx={{ flexGrow: 1, overflowY: "auto", padding: "15px", maxHeight: "450px",   }}>
              <Grid container spacing={2}>
                {filters.map((filter: any) => (
                  <ColumnGrid key={filter.field} filter={filter} filterValues={filterValues} handleChange={handleChange} onOtherComponentChange={onOtherComponentChange} />
                ))}
              </Grid>
            </Box>

            {/* Botones fijos en la parte inferior */}
            <Box sx={{ padding: "15px", borderTop: "1px solid #E6E6E6", background: "#fff" }}>
              <Box display="flex" gap="10px">
                <Button onClick={resetFilters} variant="outlined" color="secondary" sx={{ flexBasis: "50%" }}>
                  {CLEAR_FILTERS_LABEL}
                </Button>
                <Button variant="contained" sx={{ flexBasis: "50%" }} onClick={applyFilters}>
                  {APPLY_LABEL}
                </Button>
              </Box>
            </Box>
          </Box>
        </LocalizationProvider>
      </Popover>


    </>
  );
};